module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-plan-flow-af87bfb470e0232e780509d7f6cd1954.png";